export default __webpack_public_path__ + "static/media/knapsack.88c58e5b.png";